import { ReactNode } from "react";
import { Content, BorderDecoratedCardWrapper, Title, TitleCn, TitleEn } from "./BorderDecoratedCard.styled";
import { CSSProperties } from "styled-components";

interface BorderDecoratedCardProps {
    titleCn: string,
    titleEn: string,
    titleBackgroundHide?: boolean,
    style?: CSSProperties,
    styleTitleCn?: CSSProperties,
    styleContent?: CSSProperties,
    children?: ReactNode[] | ReactNode,
}

let BorderDecoratedCard: React.FC<BorderDecoratedCardProps> = (props)=> {

    return <BorderDecoratedCardWrapper style={props.style}>
        <Title style={props.titleBackgroundHide ? {background: 'none'} : {}}>
            <TitleCn style={props.styleTitleCn}>{props.titleCn}</TitleCn>
            {/* <TitleEn>{props.titleEn}</TitleEn> */}
        </Title>

        <Content style={props.styleContent}>
            {props.children}
        </Content>
    </BorderDecoratedCardWrapper>
};

export default BorderDecoratedCard;

